/**
 * Resolution of a web request.
 *
 * @remarks
 * - Blocked: Request was blocked.
 * - Allowed: Request was allowed.
 * - BlockedByTime: Request was blocker because of a time lock.
 *
 * Never change the constant values!
 * Otherwise, you will get inconsistent values if the listener extension has a different module version than the controller extension.
 */
export enum Verdict {
  Blocked = 0,
  Allowed = 1,
  BlockedByTime = 2,
}
